export default __webpack_public_path__ + "static/media/leftArrowBanner.e2e47ca7.svg";